module.exports = __webpack_public_path__ + "img/ex-4.dd17e810.svg";